"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const TitanShapes_1 = require("../shapes/TitanShapes");
function List({ resource, renderAs, ...props }) {
    let resources = resource.read();
    // TODO: Look at whether this is needed?
    resources.concat(TitanShapes_1.BrandAccount.getLocalInstances().filter((a) => !resources.map((r) => r.uri).includes(a.uri) &&
        a.name !== 'Choose an account'));
    const Element = renderAs;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: resources.map((i) => ((0, jsx_runtime_1.jsx)(Element, { ...props, of: i }))) }));
}
exports.List = List;
//# sourceMappingURL=List.js.map